export const environment = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.dev.radnj.skimsi.com',
};
